<template>
  <div class="modal fade stacked-schedule-cancel-modal" id="confirmDeleteScheduleModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 v-if="getCurrentCalendar" class="modal-title fs-5">Cancelar {{ getCurrentCalendar.status == 'BLOCKED' ? 'bloqueio' : 'agendamento' }} ?</h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              
              <div class="modal-body">
                
                <p class="modal-title">
                  Essa ação não poderá ser desfeita.
                </p>
                
                <br>
                
                <p class="modal-title">
                  Após a confirmação, o horário ficará disponível para novos agendamentos.
                </p>
                
                <br>
                
                <p v-if="getCurrentCalendar" class="modal-title">
                  Para desfazer essa ação, será necessário criar um novo {{ getCurrentCalendar.status == 'BLOCKED' ? 'bloqueio' : 'agendamento' }}.
                </p>
                
                <br>

                <h1 v-if="getCurrentCalendar" class="modal-title fs-5">
                  Tem certeza que deseja cancelar o {{ getCurrentCalendar.status == 'BLOCKED' ? 'bloqueio' : 'agendamento' }} ?
                </h1>
              </div>

              <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Não cancelar</button>
                  <button type="button" class="btn btn-danger" @click="deleteSchedule">{{ textButtonConfirmAdvanced()}}</button>
              </div>
          </div>
      </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: "confirmDeleteScheduleModal",
  data () {
      return {
        selectedTime: "",
        isLoadingDelete: false,
        isLoadingUpdate: false,
      }
  },
  watch: {
    getCurrentCalendar: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.start_time_service) {
          this.selectedTime = newVal.start_time_service;
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "getCurrentCalendar",
    ]),

    safeDate() {
      if (!this.getCurrentCalendar || !this.getCurrentCalendar.date) return null;
      return new Date(this.getCurrentCalendar.date + 'T00:00:00');
    },

    formattedDate() {
      if (!this.safeDate) return '';

      return this.safeDate.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    },

    weekDay() {
      if (!this.safeDate) return '';

      const day = this.safeDate.toLocaleDateString('pt-BR', {
        weekday: 'long'
      });

      return day.charAt(0).toUpperCase() + day.slice(1);
    }
  },
  methods: {
    ...mapActions([
      "saveSchedule",
      "excludeSchedule"
    ]),

    textButtonConfirmAdvanced(){
      if(this.getCurrentCalendar && this.getCurrentCalendar.status == "BLOCKED"){
        return this.isLoadingUpdate ? 'Cancelando bloqueio...' : 'Cancelar bloqueio';
      }
      return this.isLoadingUpdate ? 'Cancelando agendamento...' : 'Cancelar agendamento';
    },

    maskTime(event){
      let value = event.target.value;

      // remove tudo que não for número
      value = value.replace(/\D/g, '');

      // limita a 4 dígitos (HHMM)
      value = value.slice(0, 4);

      // adiciona os dois pontos automaticamente
      if (value.length >= 3) {
        value = value.replace(/(\d{2})(\d+)/, '$1:$2');
      }

      event.target.value = value;
    },
    deleteSchedule(){

      if(this.selectedTime == "" || this.selectedTime == null){
        return;
      }

      this.isLoadingDelete = true;

      const params = {
        "calendar_id": this.getCurrentCalendar.id
      }

      this.excludeSchedule(params).then(() => this.isLoadingDelete = false);
    },
    updateSchedule(){

      if(this.selectedTime == "" || this.selectedTime == null){
        return;
      }

      this.isLoadingUpdate = true;

      const params = {
        "calendar_id": this.getCurrentCalendar.id,
        "selected_time": this.selectedTime,
        "date": moment(this.safeDate).format("YYYY-MM-DD")
      }

      this.saveSchedule(params).then(() => this.isLoadingUpdate = false);
    }
  }
};
</script>
